import { XVII18nService } from '@app/i18n/services';
import { I18n } from '@app/i18n/strings-keys';
import { IPdfTableHeader } from '@app/shared/common/make-pdf/pdf-table-header.type';
import { PdfHeader } from '@shared/common/make-pdf/pdf-options.type';
import { STAND_WORKSHEET_PERMISSION_CODE } from '@shared/types/enums/stand-worksheet-permission-code.enum';

export enum STAND_WORKSHEET_PDF_HEADER_NAMES {
  ItemName = 'Item Name',
  ItemId = 'Item ID',
  Unit = 'Unit',
  UnitPrice = 'Unit Price',
  ProductPrice = 'Product Price',
  ProductName = 'Product Name',
  ProductID = 'Product ID',
  TotalAvailable = 'Total Available',
  BreTotalAvailable = 'Total Avail',
  BeginningCount = 'Begin Count',
  BreBeginningCount = 'Begin Cnt',
  PreEventIn = 'Pre-Event In',
  BrePreEventIn = 'Pre In',
  MGRStartingOverride = 'MGR Starting Override',
  BreMGRStartingOverride = 'Mgr Ovrd',
  DuringEventIn = 'During Event In',
  BreDuringEventIn = 'During In',
  DuringEventOut = 'During Event Out',
  BreDuringEventOut = 'During Out',
  Gratis = 'Gratis',
  IngredientSpoil = 'Spoilage',
  Adjustment = 'Adjustment',
  BreAdjustment = 'Adj',
  EndingCount = 'Ending Count',
  BreEndingCount = 'End Cnt',
  ExpectedQty = 'Expected Qty',
  BreExpectedQty = 'Exp Qty',
  TerminalQty = 'Terminal Qty',
  BreTerminalQty = 'Term Qty',
  TerminalDollars = 'Terminal Dollars',
  BreTerminalDollars = 'Term $',
  PhysicalQty = 'Physical Qty',
  BrePhysicalQty = 'Phys Qty',
  PhysicalDollars = 'Physical Dollars',
  BrePhysicalDollars = 'Phys $',
  PriceAdjustment = 'Price Adjustment',
  BrePriceAdjustment = 'Price Adj',
  PostClosureQty = 'Post-Closure Qty',
  BrePostClosureQty = 'Post-Cls Qty',
  PostClosureDollars = 'Post-Closure Dollars',
  BrePostClosureDollars = 'Post-Cls $',
  VarianceQty = 'Variance Qty',
  BreVarianceQty = 'Var Qty',
  VarianceDollars = 'Variance Dollars',
  BreVarianceDollars = 'Var $',
  Discounts = 'Discounts',
  BreDiscounts = 'Disc',
  PhysicalSales = 'Physical Sales',
  TerminalSales = 'Terminal Sales',
  PhysTerminalDiff = 'Phys/Terminal Diff',
  Taxes = 'Taxes',
  CashCount = 'Cash Count',
  CashTerminalDiff = 'Cash/Terminal Diff',
  ReceiptPhysicalDiff = 'Receipt/Physical Diff',
  CreditCards = 'Credit/Gift Cards',
  CustomTenders = 'Custom Tenders',
  CCTips = 'Tips',
  TotalDollarsDiscounted = 'Total Discounts',
  Other = 'Fees/Other',
  PostClosureSales = 'Post-Closure Sales',
  PostClosureTaxes = 'Post-Closure Taxes',
  PostClosureCreditCards = 'Post-Closure Credit/Gift Cards',
  PostClosureCustom = 'Post-Closure Custom',
  PostClosureCCTips = 'Post-Closure Tips',
  PostClosureTerminalCash = 'Post-Closure Terminal Cash',
  PostClosureDollarsDiscounted = 'Total Post-Closure Discounts',
  PostClosureDiscounted = 'Post-Closure Discounts',
  BrePostClosureDiscounted = 'Post-Cls Disc',
  TotalTaxes = 'Total Taxes',
  TotalPostClosureTaxes = 'Total Post-Closure Taxes',
  BrePostClosureTaxes = 'Post-Cls Taxes',
  Cash = 'Terminal Cash',
}

export enum STAND_WORKSHEET_PDF_HEADER_VALUES {
  FormattedChargeable = 'formattedChargeable',
  ItemName = 'name',
  ItemId = 'code',
  Unit = 'unit',
  ProductPrice = 'parent_product_price',
  ProductName = 'parent_product_name',
  ProductID = 'parent_product_id',
  UnitPrice = 'parent_product_price',
  TotalAvailable = 'total_available',
  BeginningCount = 'begin',
  PreEventIn = 'pre_event_in',
  MGRStartingOverride = 'manager_begin',
  DuringEventIn = 'during_event_in',
  DuringEventOut = 'during_event_out',
  Gratis = 'gratis',
  IngredientSpoil = 'ingredient_spoil',
  Adjustment = 'adjustment',
  ExpectedQty = 'expected_qty',
  EndingCount = 'end',
  TerminalQty = 'sale',
  TerminalDollars = 'price',
  PhysicalQty = 'physical_qty',
  PhysicalDollars = 'physical_dollars',
  PriceAdjustment = 'price_adjustment',
  PostClosureQty = 'sale_post_closure',
  PostClosureDollars = 'price_post_closure',
  VarianceQty = 'variance_qty',
  VarianceDollars = 'variance_dollars',
  From = 'qoh_from',
  To = 'qoh_to',
  TransferUnit = 'transfer_unit',
  Quantity = 'count',
  UnitCost = 'item_cost',
  TotalCost = 'total_cost',
  PhysicalSales = 'physical_sales',
  TerminalSales = 'terminal_sales',
  PhysTerminalDiff = 'phys_terminal_diff',
  CashCount = 'cash_count',
  ReceiptPhysicalDiff = 'receipt_physical_diff',
  CashTerminalDiff = 'cash_terminal_diff',
  CreditCards = 'credit_debit_gift_total',
  CustomTenders = 'custom',
  TotalDollarsDiscounted = 'total_dollars_discounted',
  PostClosureDollarsDiscounted = 'post_closure_dollars_discounted',
  DiscountPostClosure = 'discount_post_closure',
  CCTips = 'tips',
  GiftCards = 'gift',
  Other = 'miscellaneous',
  PostClosureSales = 'post_closure_sales',
  PostClosureCreditCards = 'credit_debit_gift_post_closure_total',
  PostClosureCustom = 'custom_post_closure',
  PostClosureCCTips = 'tips_post_closure',
  PostClosureTerminalCash = 'cash_post_closure',
  PostClosureGiftCards = 'gift_post_closure',
  ReceiptTotal = 'receipt_total',
  Discounts = 'discount',
  Taxes = 'tax',
  PostClosureTaxes = 'tax_post_closure',
  TotalTaxes = 'total_tax',
  TotalPostClosureTaxes = 'total_tax_post_closure',
  Cash = 'cash',
}

export enum STAND_WORKSHEET_PDF_SUMMARY_NAMES {
  Event = 'Event: ',
  EventStart = 'Event Start: ',
  Chargeable = 'Chargeable: ',
  Site = 'Site: ',
  EventEnd = 'Event End: ',
  Unit = 'Unit: ',
  Status = 'Status: ',
}

export const ENTRY_FORM_PDF_HEADERS = (
  i18nService: XVII18nService,
): PdfHeader[] => {
  return [
    {
      header: {
        text: '',
        width: '1%',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.FormattedChargeable,
      required: true,
      defaultDisabled: true,
    },
    {
      header: {
        text: I18n.Forms.GridForm.ItemName,
        width: '15%',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.ItemName,
      required: true,
      defaultDisabled: true,
    },
    {
      header: {
        text: I18n.Forms.GridForm.ItemID,
        width: '5.25%',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.ItemId,
    },
    {
      header: {
        text: I18n.Forms.GridForm.ProductName,
        width: '5.25%',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.ProductName,
    },
    {
      header: {
        text: I18n.Forms.GridForm.ProductID,
        width: '5.25%',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.ProductID,
    },
    {
      header: {
        text: I18n.Forms.GridForm.UnitPrice,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.UnitPrice,
      required: true,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.BeginCnt,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.BeginningCount,
      fullName: I18n.Forms.StandWorksheetForm.BeginCount,
      permissionCode: STAND_WORKSHEET_PERMISSION_CODE.BeginningCount,
      required: true,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.PreIn,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.PreEventIn,
      fullName: I18n.Forms.StandWorksheetForm.PreEventIn,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.MgrOvrd,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.MGRStartingOverride,
      fullName: I18n.Forms.StandWorksheetForm.MGRStartingOverride,
      required: true,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.TotalAvail,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.TotalAvailable,
      fullName: I18n.Forms.StandWorksheetForm.TotalAvailable,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.DuringIn,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.DuringEventIn,
      fullName: I18n.Forms.StandWorksheetForm.DuringEventIn,
      required: true,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.DuringOut,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.DuringEventOut,
      fullName: I18n.Forms.StandWorksheetForm.DuringEventOut,
      required: true,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.Gratis,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.Gratis,
      required: true,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.Spoilage,
        width: '6.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.IngredientSpoil,
      required: true,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.Adj,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.Adjustment,
      fullName: I18n.Forms.StandWorksheetForm.Adjustment,
      permissionCode: STAND_WORKSHEET_PERMISSION_CODE.Adjustment,
      required: true,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.ExpQty,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.ExpectedQty,
      fullName: I18n.Forms.StandWorksheetForm.ExpectedQty,
      permissionCode: STAND_WORKSHEET_PERMISSION_CODE.ExpectedQty,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.EndCnt,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.EndingCount,
      fullName: I18n.Forms.StandWorksheetForm.EndingCount,
      required: true,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.TermQty,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.TerminalQty,
      fullName: I18n.Forms.StandWorksheetForm.TerminalQty,
      required: true,
    },
    {
      header: {
        text: `${i18nService.instant(I18n.Forms.StandWorksheetForm.Term)}$`,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.TerminalDollars,
      fullName: I18n.Forms.StandWorksheetForm.TerminalDollars,
      required: true,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.PhysQty,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.PhysicalQty,
      fullName: I18n.Forms.GridForm.PhysicalQty,
      required: true,
    },
    {
      header: {
        text: `${i18nService.instant(I18n.Forms.StandWorksheetForm.Phys)}$`,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.PhysicalDollars,
      fullName: I18n.Forms.StandWorksheetForm.PhysicalDollars,
      required: true,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.PriceAdj,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.PriceAdjustment,
      fullName: I18n.Forms.StandWorksheetForm.PriceAdjustment,
      required: true,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.Taxes,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.Taxes,
      fullName: I18n.Forms.StandWorksheetForm.Taxes,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.Disc,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.Discounts,
      fullName: I18n.Forms.StandWorksheetForm.Discounts,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.PostClsQty,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.PostClosureQty,
      fullName: I18n.Forms.StandWorksheetForm.PostClosureQty,
    },
    {
      header: {
        text: `${i18nService.instant(I18n.Forms.StandWorksheetForm.PostCls)}$`,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.PostClosureDollars,
      fullName: I18n.Forms.StandWorksheetForm.PostClosureDollars,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.PostClsTaxes,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.PostClosureTaxes,
      fullName: I18n.Forms.StandWorksheetForm.PostClosureTaxes,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.PostClsDisc,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.DiscountPostClosure,
      fullName: I18n.Forms.StandWorksheetForm.PostClosureDiscounts,
    },
    {
      header: {
        text: I18n.Forms.StandWorksheetForm.VarQty,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.VarianceQty,
      fullName: I18n.Forms.StandWorksheetForm.VarianceQty,
      required: true,
    },
    {
      header: {
        text: `${i18nService.instant(I18n.Forms.StandWorksheetForm.Var)}$`,
        width: '5.25%',
        textAlign: 'right',
      },
      dataKey: STAND_WORKSHEET_PDF_HEADER_VALUES.VarianceDollars,
      fullName: I18n.Forms.StandWorksheetForm.VarianceDollars,
      required: true,
    },
  ];
};

export const INFORMATION_PDF_HEADERS_WITHOUT_POST_CLOSURE: IPdfTableHeader[] = [
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.TotalDollarsDiscounted,
    title: I18n.Forms.StandWorksheetForm.TotalDiscounts,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.Other,
    title: I18n.Forms.StandWorksheetForm.FeesOther,
  },
];

export const INFORMATION_PDF_HEADERS_PART_ONE: IPdfTableHeader[] = [
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.PhysicalSales,
    title: I18n.Forms.StandWorksheetForm.PhysicalSales,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.TerminalSales,
    title: I18n.Forms.StandWorksheetForm.TerminalSales,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.PhysTerminalDiff,
    title: I18n.Forms.StandWorksheetForm.PhysTerminalDiff,
    width: '15%',
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.TotalTaxes,
    title: I18n.Forms.StandWorksheetForm.TotalTaxes,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.CashCount,
    title: I18n.Forms.StandWorksheetForm.CashCount,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.ReceiptPhysicalDiff,
    title: I18n.Forms.StandWorksheetForm.ReceiptPhysicalDiff,
    width: '15%',
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.CreditCards,
    title: I18n.Forms.StandWorksheetForm.CreditGiftCards,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.Cash,
    title: I18n.Forms.StandWorksheetForm.TerminalCash,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.CustomTenders,
    title: I18n.Forms.StandWorksheetForm.CustomTenders,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.CCTips,
    title: I18n.Forms.StandWorksheetForm.Tips,
  },
];

export const INFORMATION_PDF_HEADERS_PART_TWO: IPdfTableHeader[] = [
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.TotalDollarsDiscounted,
    title: I18n.Forms.StandWorksheetForm.TotalDiscounts,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.Other,
    title: I18n.Forms.StandWorksheetForm.FeesOther,
    width: '7%',
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.PostClosureSales,
    title: I18n.Forms.StandWorksheetForm.PostClosureSales,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.TotalPostClosureTaxes,
    title: I18n.Forms.StandWorksheetForm.TotalPostClosureTaxes,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.PostClosureCreditCards,
    title: I18n.Forms.StandWorksheetForm.PostClosureGiftCards,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.PostClosureCustom,
    title: I18n.Forms.StandWorksheetForm.PostClosureCustom,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.PostClosureCCTips,
    title: I18n.Forms.StandWorksheetForm.PostClosureTips,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.PostClosureTerminalCash,
    title: I18n.Forms.StandWorksheetForm.PostClosureTerminalCash,
  },
  {
    path: STAND_WORKSHEET_PDF_HEADER_VALUES.PostClosureDollarsDiscounted,
    title: I18n.Forms.StandWorksheetForm.TotalPostClosureDiscounts,
    width: '15.222%',
  },
];
